module.exports = __webpack_public_path__ + "static/media/46.db85d679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/46.jpg
// module id = 607
// module chunks = 0